const isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;

const isIos =
  (/iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !(window as any).MSStream;

export const isMobileDevice = isIos || isAndroid;

const iosDeviceFromUserAgent = /iPad|iPhone|iPod/.exec(window.navigator.userAgent);

export const iosDevice = isIos
  ? iosDeviceFromUserAgent
    ? iosDeviceFromUserAgent[0]
    : navigator.platform === 'MacIntel'
    ? 'iPad'
    : null
  : null;

export const isPwa = !!(
  (window.navigator as any).standalone ||
  (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
);

// Detect if Safari
export const isSafari = /Safari/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent);

export const posteMessageToServiceWorkerWithPWAType = () => {
  if (isPwa) {
    navigator.serviceWorker?.controller?.postMessage({ type: 'IS_STANDALONE' });
  } else {
    navigator.serviceWorker?.controller?.postMessage({ type: 'IS_BROWSER' });
  }
};
